<template>
  <v-btn
    class="login-social-button"
    :disabled="disabled"
    :loading="redirecting"
    @click="handleClick">
    <div
      class="wrapper px-5 py-1 my-2"
      :class="provider">
      <img
        style="width: 30px"
        :src="`https://eventeros.b-cdn.net/static/svg/${this.provider}.svg`">
      <div>
        {{this.buttonText}}
      </div>
    </div>
  </v-btn>
</template>

<script>
export default {
  name: 'LoginWithSocialButton',
  props: {
    provider: {
      type: String,
      default: null,
    },
    disabled: {
      default: false,
    },
  },
  data() {
    return {
      EVENTEROS_API_URL: process.env.VUE_APP_EVENTEROS_API_URL,
      FRONTOFFICE_URL: process.env.VUE_APP_FRONTOFFICE_URL,
      redirecting: false,
    };
  },
  computed: {
    buttonText() {
      return `INGRESAR CON ${this.provider.toUpperCase()}`;
    },
    loginUrl() {
      let url = null;
      if (!this.disabled) {
        url = this.getProviderLoginUrl();
      }
      return url;
    },
  },
  methods: {
    getProviderLoginUrl() {
      const next = this.$cookie.get('next');
      let providerUrl = `${this.EVENTEROS_API_URL}/oauth/login/${this.provider}?redirect=${this.getRedirectURI(this.provider)}`;
      if (next && next !== '/') {
        providerUrl = `${providerUrl}&next=${next}`;
      }
      return providerUrl;
    },
    getRedirectURI(provider) {
      return encodeURIComponent(`${this.FRONTOFFICE_URL}/login/${provider}/callback`);
    },
    handleClick() {
      this.redirecting = true;
      this.$emit('redirecting');
      window.location.href = this.loginUrl;
    },
  },
};
</script>

<style lang="scss" scoped>

.login-social-button {
  padding: 0px!important;

  .wrapper {
    display: flex;
    width: 100%;
    border-radius: 6px;
    justify-items: center;
    align-items: center;

    img {
      width: 35px;
      height: 35px;
    }

    div {
      flex-grow: 1;
      text-align: center;
    }

    &.facebook {
      background-color: #1877F2;
      color: #fff;

      img {
        filter: brightness(0) invert(1);
      }
    }

    &.google {
      background-color: #EDEFF1;
      color: #000;
    }

  }

  &:disabled {
    opacity: .6;

    .wrapper.facebook,
    .wrapper.google {
      background-color: inherit;
    }
  }

}

</style>
